import { useState, useMemo } from 'react';
import { useFiltersByName } from './useFiltersByName';
import { stableSort, getSorting, Order } from 'src/utils/tableSort';

export interface ISortTable {
  order: Order;
  orderBy: string;
  data: Array<any>;
}

const useSortTable = <T>(dataList: Array<T>) => {
  const key = dataList.length < 1 ? '' : Object.keys(dataList[0])[0];
  const [sortTable, setSortTable] = useState<ISortTable>({
    order: 'asc',
    orderBy: key,
    data: stableSort(dataList, getSorting('asc', key))
  });
  const { order, orderBy } = sortTable;

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: string
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setSortTable((prev) => ({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property,
      data: stableSort(prev.data, getSorting(isAsc ? 'desc' : 'asc', property))
    }));
  };

  return { sortTable, setSortTable, handleRequestSort };
};

export const useTable = <T>(dataList: Array<T & { name: string }>) => {
  const { filteredList, handleFilter, findByKeyword } =
    useFiltersByName<T>(dataList);

  const { sortTable, setSortTable, handleRequestSort } =
    useSortTable<T>(filteredList);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useMemo(() => {
    // if (dataList.length !== filteredList.length) setPage(1);
    // if (
    //   Math.ceil(dataList.length / rowsPerPage) !== page &&
    //   dataList.length > filteredList.length
    // )
    //   setPage(Math.ceil(dataList.length / rowsPerPage));

    setSortTable((prev) => ({ ...prev, data: filteredList }));
  }, [dataList.length, filteredList, setSortTable]);

  const { order, data, orderBy } = sortTable;

  const [dataListByPage, setdataListByPage] = useState<Array<T>>(
    data.slice((page - 1) * rowsPerPage, page * rowsPerPage)
  );

  useMemo(() => {
    setdataListByPage(data.slice((page - 1) * rowsPerPage, page * rowsPerPage));
  }, [data, page, rowsPerPage]);

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
    setdataListByPage(
      data.slice((newPage - 1) * rowsPerPage, newPage * rowsPerPage)
    );
  };

  const handleChangeRowsPerPage = (value: number) => {
    setPage(1);
    setRowsPerPage(value);
    setdataListByPage(data.slice((page - 1) * value, page * value + value));
  };

  const handleSearch = (e: string) => {
    handleChangePage(1);
    handleFilter(e);
  };

  return {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    dataListByPage,
    // handleFilter,
    handleSearch,
    filteredList,
    findByKeyword,
    handleRequestSort,
    orderBy,
    order
  };
};
